import { FC } from "react";
import { Link } from "react-router-dom";
import { dappData, DappDataType } from "../../utils/data";
import DappCard from "../Card/DappCard";
export const Content: FC = () => {
  return (
    <div className=" grid gap-5 sm:grid-cols-2 lg:grid-cols-4 h-full flex">
      {dappData.map((data: DappDataType, index) => {
        return (
          <Link to={"/details/" + data.id} key={index}>
            <div className="flex flex-col justify-between overflow-hidden text-left transition-shadow duration-200 bg-white rounded-xl shadow-xl group hover:shadow-2xl cursor-pointer">
              <div className="flex flex-col justify-between overflow-hidden text-left transition-shadow duration-200 bg-white rounded-xl shadow-xl group hover:shadow-2xl">
                <DappCard dappData={data} />
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};
